/**
 * Presentational block for chat list: name, time, message preview.
 */

export interface ChatListItemContentProps {
  displayName: string;
  timeLabel: string;
  previewText: string;
  isUnread: boolean;
  isLocked?: boolean;
}

export function ChatListItemContent({
  displayName,
  timeLabel,
  previewText,
  isUnread,
  isLocked = false,
}: ChatListItemContentProps) {
  return (
    <div className="min-w-0 flex-1">
      <div className="mb-1 flex items-center justify-between">
        <h3
          className={`truncate text-base font-medium text-gray-900 ${isUnread && !isLocked ? "font-semibold" : ""}`}
          style={{ fontFamily: "Nunito, sans-serif" }}
        >
          {displayName}
        </h3>
        {!isLocked && <span className="ml-2 flex-shrink-0 text-sm text-gray-500">{timeLabel}</span>}
      </div>
      <p className={`truncate text-sm text-gray-600 ${isUnread && !isLocked ? "font-semibold text-gray-900" : ""}`}>
        {previewText}
      </p>
    </div>
  );
}
